/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import { Card, List, Spin } from "antd";
import "./style.css";
import { Table } from "antd";
import { useSelector } from "react-redux";
import { State } from "../../model/application/state";
import { LoadingOutlined } from "@ant-design/icons";
import { Props } from "../../model/application/props";

const antIcon = <LoadingOutlined style={{ fontSize: 20, color: "green" }} spin rev={undefined} />;

export const MobileList: React.FC<Props.DataTableProps> = (props) => {
  const { apiLoaderState }: any = useSelector((state) => state);
  const api: State.APILoader = apiLoaderState;
  const pagination = {
    pageSize: props.pageSize,
    total: props.total,
    onChange: props.paginationOnChange,
    itemRender: function (current: any, type: any, originalElement: any) {
      if (type === "prev") {
        return <a style={{ color: "grey" }}>Previous</a>;
      }
      if (type === "next") {
        return <a style={{ color: "white" }}>Next</a>;
      }
      return originalElement;
    },
  };
  return (
    <List
      pagination={pagination}
      loading={{indicator: antIcon, spinning: api.loading}}
      dataSource={props.rows}
      renderItem={props.renderItems}
    />
  );
};

export const DataTable: React.FC<Props.DataTableProps> = (props) => {
  const { apiLoaderState }: any = useSelector((state) => state);
  const api: State.APILoader = apiLoaderState;
  const pagination = {
    pageSize: props.pageSize ?? props.size,
    total: props.total,
    onChange: props.paginationOnChange,
    showSizeChanger: props.showChanger,
    itemRender: function (current: any, type: any, originalElement: any) {
      if (type === "prev") {
        return <a style={{ color: "grey" }}>Previous</a>;
      }
      if (type === "next") {
        return <a style={{ color: "white" }}>Next</a>;
      }
      return originalElement;
    },
  };
  return (
    <>
      <Spin
        spinning={api?.loading === true}
        indicator={antIcon}
        style={{
          color: "green",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
        tip="Please wait..."
      >
        <Card
          style={{
            marginTop: "30px",
            width: "auto",
            height: "auto",
            borderRadius: "5px",
            // boxShadow:
            //   "0 10px 15px -3px rgb(0, 0, 0, 0.1), 0 4px 6px -4px rgb(0, 0, 0, 0.1)",
            overflow: "auto",
            marginRight: 10
          }}
          // className="shadow-md"
        >
          <div
            style={{ fontSize: "14px", overflow: "auto" }}
            // data-aos="zoom-in-up"
          >
            <Table
              pagination={pagination}
              columns={props.columns}
              dataSource={props.rows}
              scroll={{ x: 1200 }}
              style={{ overflow: "auto" }}
            />
          </div>
        </Card>
      </Spin>
    </>
  );
};
